/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-01-09 08:45:02
 * @LastEditTime: 2019-08-13 12:06:04
 * @LastEditors: Please set LastEditors
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import axios from 'axios';
import store from './store';



var env = 'product'

var isDev = process.env.NODE_ENV === 'development';
var ajax = axios.create({
    // baseURL: isDev ? 'http://192.168.0.107:8090' : "/",
    timeout: 0
});

Vue.prototype.$ajax = ajax
Vue.config.productionTip = false
if (env == 'dev') {
    Vue.prototype.ajaxbaseurl = 'http://192.168.0.141:1150'
} else {
    Vue.prototype.ajaxbaseurl = 'https://api.fjdaze.com/koutu'
}
Vue.prototype.env = env
    // Vue.prototype.ajaxbaseurl='http://192.168.0.17:11909'
    //Vue.prototype.ajaxbaseurl = 'https://api.fjdaze.com/koutu' //负载
    //Vue.prototype.ajaxbaseurl='http://114.115.151.18:1909' //不负载
    //Vue.prototype.ajaxbaseurl = 'http://192.168.0.141:8090'
    //Vue.prototype.ajaxbaseurl = 'http://192.168.0.107:1904'

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')